import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import FormErrorMessage from "Components/Shared/FormComponents/FormErrorMessage/FormErrorMessage";
import { CreateDisbursementFormFields } from "../Hooks/useCreateDisbursementForm";
import { filterPayableBankAccounts } from "Modules/FilterBankAccounts";
import { useEmployeeProfileQuery } from "Hooks/useEmployeeProfileQueryContext";
import { DPReactSelect } from "Components/DP/DPReactSelect/DPReactSelect";

const BankAccountSelect = () => {
  const { userDetails } = useEmployeeProfileQuery();
  const { errors, control } = useFormContext<CreateDisbursementFormFields>();
  if (!userDetails) {
    return null;
  }

  const providerBankAccount = userDetails.employee.providerBankAccount;
  const payableAccounts = filterPayableBankAccounts(
    userDetails.employee.firstName!,
    providerBankAccount,
    userDetails.employee.userBankAccounts?.items || [],
  );

  const defaultBankAccount = providerBankAccount && payableAccounts.find(
    payableAccount => payableAccount.value === providerBankAccount.id
  );

  return (
    <>
      <Controller
        name="bankAccountOption"
        control={control}
        defaultValue={defaultBankAccount}
        rules={{ required: true }}
        options={payableAccounts}
        as={<DPReactSelect />}
      />
      <FormErrorMessage
        showError={!!errors.bankAccountOption}
        labelFor="bankAccountOption"
        message="Please select a bank account"
      />
    </>
  );
};

export default BankAccountSelect;
